import VueFlexibleJs from 'vue-flexible-js'

export default function(Vue, optoins) {
    VueFlexibleJs(Vue, optoins)
}